module.exports = __webpack_public_path__ + "static/media/Cactus_Flower.e16372c9.webp";